import { useEffect, useState } from 'preact/hooks';

export default function useIsTouchDevice() {
	const [isTouchDevice, setIsTouchDevice] = useState(false);

	useEffect(() => {
		const handleTouch = () => {
			setIsTouchDevice(true);
		};

		window.addEventListener('touchend', handleTouch, { once: true });

		return () => {
			document.removeEventListener('touchend', handleTouch);
		};
	}, [isTouchDevice]);

	return isTouchDevice;
}
